import React from 'react';
import { Button } from 'Views/Components/Button/Button';
import { getCurrentLanguageLocale, getCurrentLanguageName } from 'Stores/LanguageStore';
import useDeviceDetect from 'Hooks/useDeviceDetect';

export function LanguageNavBarButton({ transparent }: { transparent: boolean }) {
	const { isIpad } = useDeviceDetect();
	return (
		<Button
			onClick={() => {}}
			className={`language-nav-bar__button ${isIpad ? 'icon-only' : ''}`}
			icon={{ icon: 'globe', iconPos: 'icon-left' }}
		>
			{!isIpad ? getCurrentLanguageName() : ''}
		</Button>
	);
}
